import { NgModule } from '@angular/core';

import {
  DeleteProjektStatusCommandServiceModule,
  DeleteProjektStatusCommandComponentModule
} from '.';

@NgModule({
  imports: [
    DeleteProjektStatusCommandServiceModule,
    DeleteProjektStatusCommandComponentModule
  ],
  exports: [
    DeleteProjektStatusCommandServiceModule,
    DeleteProjektStatusCommandComponentModule
  ]
})
export class DeleteProjektStatusCommandModule { }
